import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi-calendar-event" }, null, -1)

import { Timespending } from '@/app.context/workspace/Event';
import { TimeSegment } from '@/logic/_infra/time';



export default /*#__PURE__*/_defineComponent({
  __name: 'Timespending_Timeline',
  props: {
    item: {},
    offset: {}
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createTextVNode(" " + _toDisplayString(_ctx.item.title) + " #" + _toDisplayString(_ctx.item.objects.ticket?.n ?? 0) + " [" + _toDisplayString(_ctx.item.segment.toString_Short(_ctx.offset)) + "] ", 1)
  ], 64))
}
}

})